import {
  RadialBar,
  RadialBarChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

interface IPieChartGraph {
  dataSet: Record<any, any>[];
  dataMap: Record<any, any>[];
  toolTipComp?: any;
}

function PieChartGraph({ dataSet, dataMap, toolTipComp }: IPieChartGraph) {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <RadialBarChart
        data={dataSet}
        endAngle={360}
        innerRadius={110}
        outerRadius={160}
      >
        {dataMap?.map((dataUnit) => {
          return (
            <RadialBar
              key={dataUnit.key}
              dataKey={dataUnit.key}
              stackId="a"
              className={dataUnit.colorClass}
            />
          );
        })}
        <Tooltip cursor={false} content={toolTipComp} />
      </RadialBarChart>
    </ResponsiveContainer>
  );
}

export default PieChartGraph;
